export default __webpack_public_path__ + "static/media/chevron_rightIcon.a2c2f1c1.svg";